
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.43 8.66c-2.06-4.43-3.13-6.12-6.5-6-1.2 0-.91-.87-1.83-.53S6 2.91 5 3.68c-2.58 2.15-2.34 4.14-1.12 8.89.51 2-1.24 2.1-.54 4 .51 1.41 4.23 2 8.16.55s6.41-4.35 5.9-5.76c-.7-1.91-2.1-.84-2.97-2.7zM11.07 16c-3.51 1.3-6.39.54-6.51.2-.21-.59 1.13-2.55 5.14-4s6.25-.94 6.48-.28c.14.31-1.61 2.74-5.11 4.08zm-1.13-3.2A13.14 13.14 0 006 15a2.77 2.77 0 002.75.25c1.38-.51 2.23-1.69 1.89-2.63z"}})])
          )
        }
      }
    